let c = 1;

export function genLocal() {
  return (c++).toString(16);
}
